import { Download, FileText, RefreshCw, PenTool } from 'lucide-react';

const POINTS = [
  { icon: Download, text: 'Download the moment payment clears' },
  { icon: FileText, text: 'Print-ready PDF, A4 and US Letter' },
  { icon: RefreshCw, text: 'Revised editions free for life' },
  { icon: PenTool, text: 'Written and verified by our editorial team' },
];

interface TrustRowProps {
  variant?: 'light' | 'dark';
  /** Adds the final-sale note. Use next to a payment button. */
  showFinalSale?: boolean;
  className?: string;
}

/**
 * Facts we can stand behind, placed at the point of decision. No ratings,
 * no testimonials — nothing here is unverifiable.
 */
export const TrustRow = ({
  variant = 'light',
  showFinalSale = true,
  className = '',
}: TrustRowProps) => {
  const tone =
    variant === 'dark' ? 'text-ink-surface-foreground/70' : 'text-muted-foreground/85';
  const iconTone = variant === 'dark' ? 'text-foil' : 'text-brass-deep';

  return (
    <div className={className}>
      <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-2.5">
        {POINTS.map((p) => (
          <li key={p.text} className={`flex items-start gap-2.5 text-[11px] font-light leading-relaxed ${tone}`}>
            <p.icon className={`w-3.5 h-3.5 mt-[1px] shrink-0 ${iconTone}`} strokeWidth={1.5} aria-hidden />
            {p.text}
          </li>
        ))}
      </ul>
      {showFinalSale && (
        <p className={`mt-3 text-[11px] font-light ${tone}`}>
          Digital goods — the files are yours immediately, so orders are final sale.
        </p>
      )}
    </div>
  );
};
